import api from "./api";

// Config de cobrança do backend (config.cfgboletoapiativo + janela de recebimento).
// Memoiza a promessa para não refazer a chamada a cada GeraCobrancas renderizado.
let _cache;

function carregar() {
  if (!_cache) {
    _cache = api
      .get("pagamentos/configcobranca")
      .then((r) => ({
        boletoApiAtivo: Boolean(r.data && r.data.boletoApiAtivo),
        // dias em que o BB ainda recebe o título depois do vencimento; 0/ausente
        // (API antiga) = não sabemos, e aí a tela cai no padrão conservador.
        diasLimiteRecebimento: Number(
          (r.data && r.data.diasLimiteRecebimento) || 0
        ),
      }))
      .catch(() => ({ boletoApiAtivo: false, diasLimiteRecebimento: 0 }));
  }
  return _cache;
}

export function getBoletoApiAtivo() {
  return carregar().then((c) => c.boletoApiAtivo);
}

export function getConfigCobranca() {
  return carregar();
}
